//#region src/locales/zh-Hant/tamagotchi/settings.yaml
var data = {
	"allow-visible-on-all-workspaces": {
		"title": "跨桌面可見性",
		"description": "允許視窗在所有虛擬桌面中可見，僅限 macOS。"
	},
	"spotlight": { "errors": {
		"unknown": "未知錯誤",
		"prefix": "出錯啦：{message}",
		"shortcutRegistrationFailed": "出錯啦：快捷鍵註冊失敗。"
	} },
	"pages": {
		"modules": { "mcp-server": {
			"description": "連線與管理 MCP 伺服器和工具",
			"title": "MCP 伺服器"
		} },
		"system": {
			"sections": { "section": { "window-shortcuts": { "title": "鍵盤快捷鍵" } } },
			"window-shortcuts": {
				"description": "修改視窗快捷方式",
				"title": "視窗快捷方式",
				"empty": "未設定",
				"spotlight": {
					"title": "Spotlight 快捷鍵",
					"description": "點擊快捷鍵後按下新的快捷鍵，按 Esc 取消。"
				},
				"actions": {
					"recording": "請按鍵",
					"reset": "重設"
				},
				"errors": {
					"load": "無法載入快捷鍵",
					"conflict": "此快捷鍵已被佔用。",
					"failed": "快捷鍵更新失敗",
					"requiresModifier": "請至少使用 Cmd、Ctrl、Alt 或 Super 中的一個修飾鍵。"
				},
				"toggle-move": { "label": "切換移動狀態" },
				"toggle-resize": { "label": "調整大小" },
				"toggle-ignore-mouse-event": { "label": "忽略滑鼠事件" },
				"press-keys": "請按下按鍵..."
			},
			"developer": { "sections": { "section": { "use-window-mouse": {
				"title": "使用視窗滑鼠工具",
				"description": "測試 Electron 視窗滑鼠游標位置"
			} } } }
		}
	},
	"devtools": {
		"title": "開發者",
		"pages": {
			"context-flow": { "title": "上下文流程" },
			"live2d-ambient-light": {
				"title": "Live2D 環境光",
				"description": "調整螢幕取樣與 Live2D 彩色光照著色器",
				"controls": { "title": "光源與輸出" },
				"enabled": {
					"title": "環境光",
					"description": "將環境光濾鏡套用至目前的 Live2D 模型。"
				},
				"source": {
					"title": "光源",
					"options": {
						"screen-capture": "螢幕擷取",
						"forced-color": "強制色彩"
					}
				},
				"mode": {
					"title": "光照模式",
					"options": {
						"window-gradient": "視窗漸層",
						"global": "全域環境光"
					}
				},
				"forced-color": {
					"title": "測試色彩",
					"description": "不擷取螢幕，直接套用此色彩。"
				},
				"strength": {
					"title": "光照強度",
					"description": "設定整體效果量。1 是設計值，最高 3 會加強光線包覆與逆光。"
				},
				"squint": {
					"title": "對亮度變化眯眼",
					"description": "當螢幕變亮的速度快於角色的適應速度時收窄眼睛。持續明亮的螢幕不會讓眼睛保持眯著。設為 0 可關閉。"
				},
				"main-window-note": "變更會顯示在 AIRI 主視窗中。",
				"diagnostics": {
					"title": "擷取診斷",
					"waiting": "正在等待 AIRI 主視窗傳送診斷資料。",
					"status": {
						"disabled": "已停用",
						"starting": "啟動中",
						"capturing": "擷取中",
						"forced-color": "強制色彩",
						"error": "錯誤"
					},
					"capture": {
						"title": "擷取狀態",
						"description": "檢查所選顯示器、擷取尺寸與排除區域座標。",
						"display": "顯示器與邊界",
						"video-size": "來源影片",
						"sample-size": "取樣畫面",
						"window-bounds": "AIRI 視窗邊界",
						"excluded-region": "排除區域",
						"exposure": "螢幕曝光",
						"behind-luminance": "角色背後的光線",
						"updated": "最後更新"
					},
					"preview": {
						"title": "縮小後擷取畫面",
						"description": "紅色矩形標示 AIRI 視窗。虛線矩形標示光照圖涵蓋的範圍。",
						"unavailable": "沒有可用的擷取畫面。"
					},
					"pixels": {
						"title": "像素判定",
						"total": "總計",
						"accepted": "已接受",
						"excluded": "已繪製",
						"transparent": "透明",
						"see-through": "穿透"
					},
					"maps": {
						"title": "光照圖",
						"window": "每張光照圖涵蓋 AIRI 視窗，以及四邊各半個視窗的範圍。外框標示視窗位置。",
						"unavailable": "沒有可用的環境資料。",
						"target": "實測值",
						"applied": "平滑後套用值",
						"surround": {
							"title": "環繞光照圖",
							"description": "視窗周圍與背後畫面的大範圍模糊。它帶有光線的顏色以及光線來自哪一側。"
						},
						"contact": {
							"title": "接觸光照圖",
							"description": "同一畫面的小範圍模糊。此圖驅動光線包覆與逆光邊緣。"
						}
					}
				},
				"sampling": {
					"title": "螢幕取樣",
					"capture-interval": {
						"title": "擷取間隔",
						"description": "設定螢幕取樣之間的時間。擷取串流以此速率執行。"
					},
					"response-time": {
						"title": "反應時間",
						"description": "設定取樣色彩適應螢幕變化的速度。"
					},
					"sample-width": {
						"title": "取樣尺寸",
						"description": "設定縮小後擷取畫面的寬度。畫面越寬，光照圖的細節越多。高度會跟隨你的螢幕。"
					},
					"neutral-color-weight": {
						"title": "中性色權重",
						"description": "設定低飽和色彩的最低權重。彩色內容的權重高於灰色。"
					}
				},
				"shader": {
					"title": "著色器反應",
					"dark-base": {
						"title": "亮度下限",
						"description": "設定螢幕全黑時的模型亮度。白色螢幕顯示原畫，越暗的螢幕越把模型壓向此下限。"
					},
					"base-curve": {
						"title": "亮度曲線",
						"description": "設定模型亮度在下限與原畫之間如何上升。大於 1 時，半亮的螢幕會讓模型更靠近下限。"
					},
					"local-share": {
						"title": "局部光比重",
						"description": "設定模型亮度有多少跟隨身旁的光線，而非整個螢幕。0 時模型無論視窗在哪都保持同一亮度。"
					},
					"tint": {
						"title": "染色",
						"description": "設定模型吸收多少螢幕色相。0 時只有螢幕亮度會影響模型。"
					},
					"color-boost": {
						"title": "暗光色彩增強",
						"description": "設定模型從昏暗但飽和的光線中額外吸收多少顏色。亮度維持不變，且沒有任何通道會低於無光時的模型。"
					},
					"wrap-intensity": {
						"title": "光線包覆強度",
						"description": "設定背景顏色滲入模型邊緣的強度。"
					},
					"wrap-saturation": {
						"title": "光線包覆飽和度",
						"description": "設定包覆光線保留多少螢幕色相。0 加入同等亮度的白光，1 加入完整的螢幕顏色。"
					},
					"backlight": {
						"title": "逆光",
						"description": "設定來自角色背後的光線點亮整圈細邊緣的強度。"
					},
					"wrap-diffuse": {
						"title": "光線包覆寬度",
						"description": "設定被包覆的背景顏色向模型邊緣內延伸多遠。"
					},
					"translucent-wrap": {
						"title": "減少半透明部件的包覆",
						"description": "以模型 alpha 的平方縮放光線包覆與邊緣光。以部分 alpha 繪製的部件本身已經透出桌面。"
					}
				},
				"preview-shader": {
					"title": "著色器預覽",
					"description": "以測試卡執行實際著色器，使用實時環境與上方的設定。",
					"window-mapping": "濾鏡把此畫布當成整個舞台視窗，因此預覽不是舞台的像素級複製。",
					"filtered": "著色器輸出",
					"unavailable": "預覽需要 WebGL，但此視窗無法建立繪圖環境。",
					"environment": {
						"live": "光線來自 AIRI 主視窗發布的最新快照。",
						"neutral": "尚未收到快照，因此預覽使用中性環境。"
					},
					"regions": {
						"title": "測試卡區域",
						"body": "寬大的主體帶有從 sRGB {low} 到 {high} 的明暗漸層。亮度、對比、彩度與高光餘裕都會沿著它顯示。",
						"bars": "長條寬度分別為 {first}、{second}、{third}、{fourth} 與 {fifth} 像素，用來顯示光線包覆延伸進細窄形狀的距離。",
						"patches": "兩個色塊以 {strong} 與 {weak} alpha 繪製，正是半透明包覆選項作用的對象。"
					}
				}
			},
			"lag-visualizer": { "title": "卡頓可視化" },
			"live2d-motion": {
				"title": "Live2D 動作控制",
				"description": "控制 Live2D 的眼睛、頭部與身體動作。",
				"actions": { "back": "返回" },
				"panels": {
					"direct-control": "直接控制",
					"preview": "模型預覽",
					"timeline": "時間軸",
					"inference": "模型推理"
				},
				"preview": {
					"groups": {
						"expression": "表情",
						"offset": "位置偏移"
					},
					"values": {
						"squint": "瞇眼",
						"mouth-form": "嘴型",
						"mouth-open": "張開"
					}
				},
				"joystick-label": "Live2D 動作搖桿",
				"instructions": "拖曳搖桿，或使用方向鍵控制 X/Y 軸。R 讓眼睛微瞇。F 讓眼睛更瞇。C 閉上眼睛。W/S 改變嘴型。空白鍵張開嘴巴。A/D 控制身體 X 軸。Q/E 讓頭部左右傾斜。放開按鍵後會平滑回到中央。",
				"parameter-note": "搖桿控制 X/Y 軸。R 映射至 1/3 瞇眼。F 映射至 2/3 瞇眼。C 映射至完全閉眼。W/S 映射至嘴型 ±1。空白鍵映射至嘴巴張開 1。A/D 映射至身體 X 軸 ±10°。Q/E 映射至頭部 Z 軸 ±30°。",
				"input": {
					"keyboard": "鍵盤",
					"controller": "控制器"
				},
				"input-actions": {
					"move-body-head": "移動身體與頭部",
					"tilt-head": "傾斜頭部",
					"blink": "眨眼",
					"open-mouth": "張開嘴巴",
					"mouth-shape": "改變嘴型"
				},
				"eye-view": {
					"title": "固定視線",
					"description": "選擇目標後，眼睛會抵銷頭部動作並持續注視目標。",
					"pad-label": "固定視線目標",
					"actions": {
						"enable": "啟用注視",
						"disable": "停用注視",
						"center": "目標置中"
					},
					"counter": {
						"label": "頭部抵銷強度",
						"description": "眼睛抵銷頭部 X/Y 軸動作的強度。"
					},
					"values": {
						"target": "目標",
						"output": "眼睛輸出"
					}
				},
				"editor": {
					"title": "動作編輯器",
					"instructions": "灰色曲線是原始動作。新增動作疊加層或視線目標關鍵影格。選取軌道後，拖曳其控制點。",
					"play": "播放時間軸",
					"pause": "暫停時間軸",
					"undo": "復原",
					"redo": "重做",
					"crop-to-view": "裁切至檢視範圍",
					"reset-view": "重設檢視",
					"export-project": "匯出專案",
					"import-project": "匯入專案",
					"import-error": "此檔案不是有效的 AIRI Live2D 動作專案。",
					"playback": {
						"label": "時間軸播放控制",
						"start": "跳至開頭",
						"step-backward": "後退一格",
						"step-forward": "前進一格",
						"end": "跳至結尾",
						"timecode": "目前與總時間碼"
					},
					"input-actions": {
						"play": "播放",
						"stop": "停止",
						"start": "跳至開頭",
						"end": "跳至結尾",
						"step-backward": "後退一格",
						"step-forward": "前進一格",
						"restart-recording": "重新錄製",
						"clear-timeline": "清空時間軸",
						"previous-track": "選取上一條軌道",
						"next-track": "選取下一條軌道"
					},
					"timeline-label": "動作時間軸",
					"timeline-help": "拖曳尺規可搜尋時間。使用滾輪縮放。按住 Shift 並拖曳可平移。在所選曲線按兩下可新增控制點。每個視線目標關鍵影格會持續至下一個關鍵影格。",
					"overlay-count": "{count} 個疊加層",
					"controls": {
						"add": "相加",
						"replace": "取代",
						"create-keyframes": "建立關鍵影格",
						"weight": "權重",
						"remove": "移除"
					},
					"tracks": {
						"viewTargetX": "視線目標 X",
						"viewTargetY": "視線目標 Y",
						"eyeX": "眼睛 X",
						"eyeY": "眼睛 Y",
						"eyeOpen": "眼睛張開",
						"headX": "頭部 X",
						"headY": "頭部 Y",
						"headZ": "頭部 Z",
						"bodyX": "身體 X",
						"bodyY": "身體 Y",
						"bodyZ": "身體 Z",
						"mouthForm": "嘴型",
						"mouthOpen": "嘴巴張開"
					}
				},
				"var": {
					"title": "VAR 待機動作產生器",
					"description": "擬合已錄製動作，再產生新的待機動作序列。",
					"actions": {
						"fit": "擬合目前動作",
						"refit": "重新擬合目前動作",
						"generate": "產生動作",
						"stop": "停止產生",
						"new-seed": "新種子"
					},
					"order": {
						"label": "VAR 階數",
						"description": "每次預測使用的先前影格數。"
					},
					"residual": {
						"label": "殘差強度",
						"description": "產生的變化量；零代表確定性預測。"
					},
					"diagnostics": {
						"source": "來源",
						"model": "模型",
						"fit": "擬合",
						"run": "已產生動作"
					},
					"status": {
						"no-source": "請先匯入或錄製動作",
						"source-ready": "{count} 個取樣 · {duration}s",
						"fit-failed": "VAR 擬合失敗。"
					},
					"values": {
						"frames": "{count} 個影格",
						"model": "{channels} 個通道 · {features} 個項目",
						"fit": "{frames} 個影格 · RMSE {error} · {duration}ms",
						"run": "種子 {seed} · {duration}"
					}
				},
				"ar-hmm": {
					"title": "AR-HMM 待機動作產生器",
					"description": "學習動作狀態與轉換，以產生更多變化的待機動作。",
					"actions": {
						"fit": "擬合動作",
						"refit": "重新擬合",
						"generate": "產生",
						"stop": "停止",
						"new-seed": "新種子"
					},
					"states": {
						"label": "隱藏狀態",
						"description": "模型可學習的動作模式數量。"
					},
					"order": {
						"label": "AR 階數",
						"description": "每個狀態使用的先前影格數。"
					},
					"residual": {
						"label": "創新強度",
						"description": "每個狀態內的變化量。"
					},
					"diagnostics": {
						"source": "來源",
						"model": "模型",
						"fit": "擬合",
						"states": "狀態占比",
						"run": "已產生動作"
					},
					"status": {
						"no-source": "請先匯入或錄製動作",
						"source-ready": "{count} 個取樣 · {duration}s",
						"fit-failed": "AR-HMM 擬合失敗。"
					},
					"values": {
						"count": "{count} 個狀態",
						"frames": "{count} 個影格",
						"model": "{states} 個狀態 · {channels} 個通道 · {features} 個項目",
						"fit": "log p/影格 {likelihood} · {duration}ms",
						"states": "{occupancy} · 停留 {dwell}s",
						"run": "狀態 {state} · 種子 {seed} · {duration}"
					}
				},
				"output-filter": {
					"title": "產生器輸出濾波器",
					"description": "在彈簧接收每個姿勢前，平滑產生器輸出並抑制微小變化。",
					"actions": {
						"enable": "啟用濾波器",
						"disable": "停用濾波器",
						"reset": "重設狀態"
					},
					"smoothing": {
						"label": "EMA 平滑",
						"description": "將每個接受的目標與上一個輸出混合。數值越高，移除的抖動越多，但延遲也越長。"
					},
					"cutoff": {
						"label": "變化截止值",
						"description": "在累積的正規化變化達到此值前，保持通道的上一個目標。"
					},
					"diagnostics": {
						"status": "狀態",
						"input-change": "原始變化 MAE",
						"output-change": "濾波後變化 MAE",
						"cutoff-tracks": "保持的通道"
					},
					"status": {
						"waiting": "等待產生器",
						"filtering": "正在濾波產生器輸出",
						"bypassed": "正在傳遞原始產生器輸出"
					}
				},
				"breath": {
					"title": "手動呼吸",
					"description": "使用可調整的吸氣、呼氣與停留時間控制 ParamBreath，且不將呼吸資料加入錄製內容。",
					"actions": {
						"enable": "啟用呼吸",
						"disable": "停用呼吸",
						"reset": "重設週期"
					},
					"cycle": {
						"label": "呼吸時間",
						"description": "設定一次吸氣與呼氣的時間，不包含呼氣後停留。"
					},
					"inhale": {
						"label": "吸氣占比",
						"description": "設定呼吸時間中用於吸氣的比例。剩餘時間用於呼氣。"
					},
					"dwell": {
						"label": "呼氣後停留",
						"description": "在下一次吸氣前，將 ParamBreath 保持在最小值。"
					},
					"minimum": {
						"label": "最小值",
						"description": "設定寫入 ParamBreath 的最低值。"
					},
					"maximum": {
						"label": "最大值",
						"description": "設定寫入 ParamBreath 的最高值。"
					},
					"diagnostics": {
						"stage": "階段",
						"phase": "週期進度",
						"output": "ParamBreath 輸出"
					},
					"stage": {
						"inhale": "吸氣",
						"exhale": "呼氣",
						"dwell": "呼氣後停留"
					}
				},
				"spring": {
					"follow": {
						"label": "跟隨",
						"description": "動作跟隨搖桿的速度。"
					},
					"inertia": {
						"label": "慣性",
						"description": "動作保留的動量。"
					}
				},
				"groups": {
					"eyes": "眼睛",
					"head": "頭部",
					"body": "身體"
				},
				"recording": {
					"actions": {
						"record": "錄製",
						"stop-recording": "停止錄製",
						"play": "播放",
						"stop-playback": "停止播放",
						"export": "匯出",
						"import": "匯入"
					},
					"status": {
						"empty": "尚無動作錄製",
						"recording": "正在錄製動作",
						"playing": "正在播放動作",
						"ready": "{count} 個取樣 · {duration}"
					},
					"import-error": "此檔案不是有效的 AIRI Live2D 動作錄製檔。"
				}
			},
			"performance-visualizer": {
				"title": "效能顯示器",
				"description": "切換 FPS/長任務/記憶體覆蓋"
			},
			"markdown-stress": { "description": "使用大量聊天負載來進行 Markdown 解析與渲染的壓力測試" },
			"widgets-calling": { "title": "小工具調用" }
		}
	},
	"screen-capture": { "permissions-prompt": {
		"title": "螢幕截圖",
		"description": "螢幕與語音錄製權限對於截取螢幕或視窗來說是必要的。",
		"open-preferences": "打開系統偏好設定",
		"dismiss": "取消",
		"instructions": {
			"step-1": "打開「系統偏好設定」，從側邊欄中選擇「隱私與安全」。",
			"step-2": "在「螢幕與系統聲音錄製」以及「系統聲音錄製」區域，開啟 AIRI 的開關。",
			"step-2-note": "如果 AIRI 沒有被列出，則請手動按下「+」按鈕並從應用資料夾選擇 AIRI。"
		}
	} }
};
//#endregion
export { data as default };
